import { NormalizedNumber } from '@sparkdotfi/common-universal'

import { UseSpkFarmDataResult } from '../../../data/useSpkFarmData'
import { Token } from '@/domain/types/Token'
import { TransferFromUserFormNormalizedData } from '@/features/dialogs/common/logic/transfer-from-user/form'
import { TxOverviewRouteItem } from '@/features/dialogs/common/types'

export interface CreateTxOverviewParams {
  formValues: TransferFromUserFormNormalizedData
  spkFarmData: UseSpkFarmDataResult
  isExiting: boolean
  earnedRewards: NormalizedNumber
}

export type TxOverview =
  | { status: 'no-overview' }
  | {
      status: 'success'
      stakingToken: Token
      rewardToken: Token
      earnedRewards: NormalizedNumber
      isExiting: boolean
      routeToOutcomeToken: TxOverviewRouteItem[]
      farmName: string
    }

export function createTxOverview({
  formValues,
  spkFarmData,
  isExiting,
  earnedRewards,
}: CreateTxOverviewParams): TxOverview {
  const value = formValues.value
  if (value.eq(0)) {
    return { status: 'no-overview' }
  }

  const routeToOutcomeToken: TxOverviewRouteItem[] = createRouteToOutcomeToken({
    formValues,
    stakingToken: spkFarmData.stakingToken,
  })

  return {
    status: 'success',
    stakingToken: spkFarmData.stakingToken,
    rewardToken: spkFarmData.rewardToken,
    earnedRewards,
    routeToOutcomeToken,
    isExiting,
    farmName: 'SPK Farm',
  }
}

export interface CreateRouteToOutcomeTokenParams {
  formValues: TransferFromUserFormNormalizedData
  stakingToken: Token
}
function createRouteToOutcomeToken({
  formValues,
  stakingToken,
}: CreateRouteToOutcomeTokenParams): TxOverviewRouteItem[] {
  const outcomeTokenUsdValue = formValues.token.toUSD(formValues.value)
  const stakingTokenAmount = outcomeTokenUsdValue.div(stakingToken.unitPriceUsd)

  return [
    {
      token: stakingToken,
      usdValue: outcomeTokenUsdValue,
      value: stakingTokenAmount,
    },
    ...(stakingToken.symbol !== formValues.token.symbol
      ? [
          {
            token: formValues.token,
            usdValue: outcomeTokenUsdValue,
            value: formValues.value,
          },
        ]
      : []),
  ]
}
